import { color } from '@stockbit/ui';
import { Divider as BaseDivider } from 'antd';

import styled from 'styled-components';

interface ThemeProps {
  mode: 'light' | 'dark';
}

export const Divider = styled(BaseDivider)<ThemeProps>`
  background: none;
  border: 1px dashed;
  border-color: ${(props) =>
    props.mode === 'dark'
      ? 'rgb(238 238 238 / 25%)'
      : 'rgb(238 238 238 / 95%)'};
  border-width: 1px 0 0;
`;

export const SpecialMonitoringContainer = styled.div`
  padding: 0;
  padding-bottom: 20px;
  margin: 0 auto;
  max-width: 500px;

  @media screen and (max-width: 500px) {
    margin: 0;
  }
`;

export const SpecialMonitoringCard = styled.div<ThemeProps>`
  border: 1px solid
    ${(props) => (props.mode === 'dark' ? '#2e2e2e' : color.downgray)};
  border-radius: 4px;
  margin-top: 20px;

  &:first-child {
    margin-top: 0;
  }
`;

export const SpecialMonitoringHeader = styled.div<ThemeProps>`
  padding: 16px 20px;
  border-bottom: 1px solid
    ${(props) => (props.mode === 'dark' ? '#2e2e2e' : color.downgray)};

  h1 {
    font-size: 14px;
    font-family: var(--bold-font);
    line-height: 19px;
  }
`;

export const SpecialMonitoringBody = styled.div<ThemeProps>`
  padding: 16px 20px;

  .special-monitoring-session-container {
    margin-top: 20px;

    p {
      margin-bottom: 8px;
    }

    .special-monitoring-session-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  ul {
    padding-inline-start: 24px;

    li {
      margin-bottom: 20px;

      &::marker {
        color: ${(props) =>
          props.mode === 'dark' ? color.lowgray : color.highempahis};
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
